<div class="doc-main-div">
  <div class="doc-top-div">
    <div class="docs-logo">
      <a href="https://searchia.ir/docs"><img src="assets/images/logo1.png" style="width: 135px"></a>
    </div>
    <div class="docs-right">
      <div class="doc-menu" *ngFor="let doc of listDocs">
        <div style="width: 100% ;">
          <i (click)="selectDoc(doc)"
             style="{{selectedDoc.id==doc.id?'color:#b30606;text-shadow: 0px 0px 1px #060200;width: 100%':'width: 100%'}} ">{{doc.label}}</i>
        </div>
      </div>
    </div>

  </div>
  <div class="doc-center-div">
    <div class="doc-right-div">
      <div class="category-tree">
        <p-tree [value]="categoryTree" emptyMessage=" " selectionMode="single" [(selection)]="selectedTree"
                (onNodeSelect)="nodePageSelect($event)"></p-tree>
      </div>
    </div>
    <div class="doc-left-div">
      <div class=" post-main-div">
        <div class="page-navigation">
          <div>{{selectedDoc.label}}</div>
          <div *ngFor="let cat of creatNavCategoryList()"><i
            class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}}"></i>{{cat.name}}</div>
          <div><i class="pi {{getDirection()=='rtl'?'pi-angle-left':'pi-angle-right'}}"></i>{{selectedPage.label}}</div>
        </div>
        <div class="select-none" style="color: #b5b2b2;padding-right: 10px;padding-top: 10px;"
             *ngIf="selectedPage && selectedPage.id>0">
          <div style="position: relative;font-size: 12px;top: 2px" class="pi pi-clock"></div>
          {{miliSecontToDate(selectedPage.lastUpdate) | jdate : "dd mmm yyyy" | faNum }}
        </div>
        <div class="grid">
          <div class="col-12 md:col-9">
            <div *ngFor="let post of selectedPage.publish_posts ; let j = index" class="grid post-div">
              <div (click)="copyToClipboard(getHost()+'/'+locale+'/docs/gotopage/'+selectedPage.uid+'/'+post.uid)"
                   class=" hashtag col-6 post-title" id="{{creatPostTag(post)}}">
                <h2 style="cursor: pointer" i18n-pTooltip="@@Link Copy" pTooltip="Link Copy" >{{post.label}}</h2> <a
                href="{{creatPostTagLink(post)}}">#</a></div>
              <div *ngFor="let item of post.postItems ; let i = index"
                   class=" {{item.itemAttribute.widthClass ?item.itemAttribute.widthClass:'col-12' }} post-item"
                   id="{{j+''+i}}">
                <!--            <div [innerHTML]="item.html_not_publish | safeHtml"></div>-->
                <div [innerHTML]="showItemInPost(post,item) | safeHtml"></div>
              </div>
            </div>
          </div>
          <div class="postList hidden md:block col-12 md:col-3 ">

            <ul>
              <div class="on-this-page" i18n="@@Titles of this page">Titles of this page</div>
              <li *ngFor="let p of postMenu | keyvalue " (click)="goToFregment(p.key)">{{p.value}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


